import { withSharedProviders } from './common/higher-order-components/with-shared-providers';
import { Router } from './routing/Router';
// Polyfill for set methods
import 'core-js/proposals/set-methods-v2';

export const App = withSharedProviders(Router);
